import { createRouter, createWebHistory } from 'vue-router'
import Report from '../components/Report.vue'
import Notfound from '../components/Notfound.vue'

const routes = [
  { path: '/', redirect: '/report' },
  { path: '/report', name: 'Report', component: Report },
  { path: '/:pathMatch(.*)*', component: Notfound }
]

export default createRouter({
  history: createWebHistory(),
  routes
})
